import { render, staticRenderFns } from "./partenr-variable.vue?vue&type=template&id=15d5f837&scoped=true&"
import script from "./partenr-variable.vue?vue&type=script&lang=js&"
export * from "./partenr-variable.vue?vue&type=script&lang=js&"
import style0 from "./partenr-variable.vue?vue&type=style&index=0&id=15d5f837&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5f837",
  null
  
)

export default component.exports